export default (state, action) => {

  return {
    ...state,
    link: '',
    images: action.images,
  };
}
